import MapFilterCheckComponent from "./MapFilterCheckComponent";

export default {
  name: 'MapFilterCheckListComponent',
  components: {
    MapFilterCheckComponent
  },
  props: ['list', 'title', 'activeList', 'disabled'],
  emits: ['update'],
  template: `
    <div v-if="list && list.length" class="partners-map-filter__section">
      <div class="partners-map-filter__section-title">
        {{title}}
      </div>
      <div class="partners-map-filter__section-list">
        <MapFilterCheckComponent v-for="item in list" :key="item.code" :name="item.name" :img="item.img" :active="activeList.includes(item.code)" :disabled="disabled" @click="$emit('update', item.code)" />
      </div>
    </div>
  `,
}
